import { render, staticRenderFns } from "./addVendorTaxDetailComponent.vue?vue&type=template&id=29259a3e&"
import script from "./addVendorTaxDetailComponent.vue?vue&type=script&lang=js&"
export * from "./addVendorTaxDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports